<template>
  <div class="container">
    <div class="row">
      <div
        class="item col-lg-4 col-sm-6 col-xs-12"
        v-for="(item, index) in catagory"
        :key="index"
      >
        <a href="#" @click.prevent="scrollTo(item.id)">
          <img :src="`/${$staticPath}/${item.src}`" class="w-100" />
          <div class="text-content text-center">
            <div class="text">
              <span>{{ item.header }}</span>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['catagory'],
  methods: {
    scrollTo (id) {
      this.$emit('scrollTo', id)
    }
  }
}
</script>

<style scoped>
.container {
  margin-bottom: 60px;
}
.item {
  margin-bottom: 30px;
  position: relative;
  height: 100%;
}

.item img {
  border: 5px solid transparent;
  cursor: pointer;
  transition: 0.35s;
}

.item:hover img {
  border: 5px solid #ffa500;
}

.item .text-content {
  position: absolute;
  left: 20px;
  right: 20px;
  bottom: 5px;
  background-image: linear-gradient(
    to top,
    rgba(23, 23, 23, 0.9),
    rgba(23, 23, 23, 0)
  );
  padding-top: 10px;
  min-height: 35%;
  transition: 0.35s;
  cursor: pointer;
}

.item:hover .text-content {
  min-height: 45%;
}

.item .text-content span {
  background-color: #ffa500;
  font-weight: 300;
  transition: 0.35s;
  padding: 0px 15px;
  color: #fff;
}

.item:hover .text-content span {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/STUDENTS/Catagory.vue